import { Component, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { DialogWrapperComponent } from '@modals/dialog-wrapper/dialog-wrapper.component';
import { MbDialogHeader, MbDialogBody } from '@am/moebius';

@Component({
  selector: 'app-modal-disney-benefits',
  standalone: true,
  imports: [MbDialogHeader, MbDialogBody],
  templateUrl: './disney-benefits.component.html',
  styleUrls: ['./disney-benefits.component.scss'],
})
export class ModalDisneyBenefitsComponent
  extends DialogWrapperComponent
  implements OnInit
{
  public env: any = environment.environment;

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  public imageBenefit(benefit: number) {
    return `/hotels/dist/es-AR/browser/assets/images/containers/detail/disney/benefits/img/b0${benefit}.jpg`;
  }
}
